const AppVersion = {"version": "v1.13.1"}; export default AppVersion;